import { ApiProperty } from '@nestjs/swagger';
import { SubdivisionSupervisorReplaceableInterface } from '../interfaces/subdivision-supervisor-replaceable.interface';
import { IsUUID } from 'class-validator';
import { Expose } from 'class-transformer';

export class SubdivisionSupervisorReplaceDto
  implements SubdivisionSupervisorReplaceableInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  subdivisionId!: string;

  @ApiProperty({
    type: [String],
    title: 'User IDs to replace',
    description: 'List of user IDs to be replaced in the subdivision',
  })
  userIds!: string[];
}
